import { useQueryResponse } from '../core/QueryResponseProvider'
import { EmpresaList } from '../core/_models'
import { empresasColumns } from './columns/_columns'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useMemo } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'

export const EmpresasTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => empresasColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.empresa
          ? `Nenhuma instituição encontrada para “${filters.empresa}”`
          : 'Nenhuma instituição com essa situação'
      }
      description='Revise o termo digitado ou a situação selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma instituição cadastrada'
      description='Cadastre a primeira instituição para começar a vincular clientes, serviços e valores.'
    />
  )

  return (
    <CustomTable<EmpresaList>
      id='kt_table_empresas'
      ariaLabel='Instituições'
      itemLabel={{ singular: t('empresa.label.lowercase'), plural: t('empresa.plural.lowercase') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
